module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.configuration === '1-2') ? _c('div', {
    staticClass: "tile-container",
    class: _vm.config
  }, [_c('div', {
    staticClass: "mid-container mid-container--1"
  }, [_vm._t("1")], 2), _vm._v(" "), _c('div', {
    staticClass: "mid-container mid-container--2"
  }, [_vm._t("2.1"), _vm._v(" "), _vm._t("2.2")], 2)]) : _vm._e(), _vm._v(" "), (_vm.configuration === '2-1') ? _c('div', {
    staticClass: "tile-container",
    class: _vm.config
  }, [_c('div', {
    staticClass: "mid-container mid-container--2"
  }, [_vm._t("2.1"), _vm._v(" "), _vm._t("2.2")], 2), _vm._v(" "), _c('div', {
    staticClass: "mid-container mid-container--1"
  }, [_vm._t("1")], 2)]) : _vm._e(), _vm._v(" "), (_vm.configuration === 'n') ? _c('div', {
    staticClass: "tile-container tile-container--n",
    class: _vm.config
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b74e2fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/custom/tile-container.vue
// module id = 169
// module chunks = 4